import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import { Presence } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import PresenceOverlay from '../containers/presenceOverlay';
import type { UserPresence } from '../reducers/presence';

import styles from './presenceListItem.module.scss';

type PropsT = {
  userPresence: UserPresence;
  index: number;
  groupIndex: number;
  ownPresence: Presence;
  ownProfile: User;
  scroll: boolean;
};

export const PresenceListItem = ({
  userPresence,
  ownProfile,
  ownPresence,
  scroll,
}: PropsT) => {
  const isOwnAgent = ownProfile.id === userPresence.user.id;
  const { user: userPresenceUser, presence: userPresencePresence } =
    userPresence;
  const isInACW = userPresencePresence.presence_status.load_descriptions.some(
    (loadDescription) => loadDescription.load_type === 'acw',
  );

  const hasActivePhoneConversation =
    userPresencePresence.presence_status.load_descriptions.findIndex(
      (loadDescription) =>
        (loadDescription.conversation_channel === 'pstnphone' ||
          (loadDescription.conversation_channel === 'callback' &&
            (loadDescription.conversation === null ||
              loadDescription.conversation?.is_callback_consumed === false))) &&
        loadDescription.load_type !== 'acw' &&
        loadDescription.load_type !== 'nonlive',
    ) > -1;
  const simRingEnabled =
    userPresencePresence.presence_status.simultaneous_ringing === true;

  const isWorking = userPresencePresence.status === 'working';
  const isAway = userPresencePresence.status === 'away';
  const isOffline = userPresencePresence.status === 'offline';
  const isAvailableForCall = isWorking || isAway;

  const rootClass = classnames({
    [styles.root]: true,
    [styles.rootOnline]: isWorking,
    [styles.rootAway]: isAway,
    [styles.rootOffline]: isOffline,
  });

  let icon = 'circle-full';
  if (hasActivePhoneConversation) {
    icon = 'phone-bold';
  } else if (isInACW) {
    icon = 'clock';
  } else if (simRingEnabled) {
    icon = 'simultaneous-bold';
  }

  return (
    <li className={rootClass}>
      <PresenceOverlay
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        isOwnAgent={isOwnAgent}
        ownProfile={ownProfile}
        ownPresence={ownPresence}
        presence={userPresencePresence}
        user={userPresenceUser}
        isAvailableForCall={isAvailableForCall}
        scroll={scroll}
      >
        <div className={styles.container}>
          <DixaIcon icon={icon} className={styles.icon} />
          <span className={styles.name}>
            {userPresenceUser.name} {isOwnAgent ? ' (you)' : ''}
          </span>
        </div>
      </PresenceOverlay>
    </li>
  );
};
